import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
@Component({
  selector: 'app-filas-modal',
  templateUrl: './filas-modal.component.html',
  styleUrls: ['./filas-modal.component.scss']
})
export class FilasModalComponent implements OnInit {

  @Input() rowData: ImputationsData;
  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {}

  deleterow(data) {
    this.delete.emit(data);
  }

  insertProject(proyectData): void {
    this.rowData.projectId = proyectData.Id;
    this.rowData.sapId = proyectData.name;

    this.update.emit(this.rowData);
  }

  deleteProject() {
    this.rowData.projectId = '';
    this.rowData.sapId = '';

    this.update.emit(this.rowData);
  }

  changeData(rowData): void {
    if (this.rowData.hours) {
      this.rowData.hours = Number(this.rowData.hours).toFixed(1);
    }
    this.update.emit(rowData);
  }

}
